<template functional>
  <div
    class="bg-gray-200 border-b border-gray-300"
    v-bind="attrs"
    :class="$options.methods.mergeFunctionalRenderContextClasses(data)"
    v-on="listeners"
  >
    <slot>
      <slot name="beforeTitle" />
      <div class="flex justify-between">
        <div>
          <slot name="title">
            <h2
              class="py-0 my-0"
              v-text="props.title"
            />
          </slot>

          <div class="mt-4">
            <slot name="info" />
          </div>
        </div>

        <div class="flex-shrink-0">
          <slot name="actions" />
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import { mergeFunctionalRenderContextClasses } from '@/helpers/utils'

export default {
  name: 'MiaCarEditPageHeader',

  props: {
    title: {
      type: String,
      default: ''
    }
  },

  methods: {
    mergeFunctionalRenderContextClasses
  }
}
</script>
